// Core
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

// Redux
import { selectCurrentUser } from "state/auth/authSlice";
import { selectCurrentCommunity } from "state/communities/communitiesSlice";

// Components
import { Crumbs, PageHead, SideTabs } from "components/AtomsV2";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";
import SimulationDashboard from "pages/SimulationDashboard";
import SizingTool from "pages/SizingTool";

function Simulation() {
  const { t } = useTranslation(["sidenav"]);
  const user = useSelector(selectCurrentUser);
  const community = useSelector(selectCurrentCommunity);
  const [tab, setTab] = useState("simulation-dashboard");

  const canSizing =
    user.permissions.find((permission) => permission?.name === "SIZING_MODULE")?.is_active ||
    user.role.name === "SUPER_USER";

  const head = (
    <>
      <HelpFloatingButtonV2 helpScreen="simulation" />
      <Crumbs items={[{ label: community?.name || "—" }, { label: t("simulation") }]} />
      <PageHead
        title={t("simulation")}
        subtitle={t("simulationdescription", { defaultValue: "" })}
      />
    </>
  );

  // Without the sizing module the page is just the simulation control card.
  if (!canSizing) {
    return (
      <div>
        {head}
        <SimulationDashboard />
      </div>
    );
  }

  const railItems = [
    { id: "simulation-dashboard", icon: "science", label: t("simulation") },
    { id: "sizing-tool", icon: "straighten", label: t("sizingtool") },
  ];

  return (
    <div>
      {head}
      <SideTabs items={railItems} active={tab} onChange={setTab}>
        {tab === "simulation-dashboard" && <SimulationDashboard />}
        {tab === "sizing-tool" && <SizingTool />}
      </SideTabs>
    </div>
  );
}

export default Simulation;
